import { nestServer } from "@erp/shared/api/axios";
import { getProject } from "@erp/shared/api/generated/wrappers/project";
/**
 * @description 수정 시 다음 사내 견적번호 또는 프로젝트 코드 생성
 * @param originalCode 기존 사내 견적번호 또는 프로젝트 코드
 */
export async function generateNextCode(originalCode) {
    if (originalCode === "") {
        return "";
    }
    if (!originalCode.includes("-")) {
        // 최초 생성 상태 → "-1" 추가
        return `${originalCode}-1`;
    }
    const response = await nestServer.get("/estimate", {
        params: { inhouseBidNumber: originalCode },
    });
    const list = response.data || [];
    const recentNums = list
        .map((item) => {
        const parts = item.inhouseBidNumber.split("-")[1];
        return Number(parts);
    })
        .filter((n) => !Number.isNaN(n));
    const maxNum = recentNums.length ? Math.max(...recentNums) : 0;
    const incremented = maxNum + 1;
    return `${originalCode}-${incremented}`;
}
/**
 * @description 저장 시 다음 사내 견적번호 생성
 * @param originalBidNumber 기존 사내 견적번호
 * @param endpoint 조회할 엔드포인트 (기본값: 견적서)
 */
export async function setInhouseBidNumber(originalBidNumber, endpoint = "/estimate") {
    if (originalBidNumber === "") {
        return "";
    }
    try {
        // 1) 백엔드에 inhouseBidNumber 쿼리로 요청
        const response = await nestServer.get(endpoint, {
            params: { inhouseBidNumber: originalBidNumber },
        });
        const list = response.data || [];
        // 2) originalBidNumber_XXX 형태만 골라서 뒤 세 자리 숫자(문자열) 추출
        const regex = new RegExp(`^${originalBidNumber}_(\\d{3})$`);
        const seqNumbers = list
            .map((item) => item.inhouseBidNumber.match(regex)?.[1])
            .filter((s) => !!s)
            .map((s) => Number(s));
        // 3) 최대값 +1, 없으면 1로 처리
        const maxSeq = seqNumbers.length ? Math.max(...seqNumbers) : 0;
        const nextSeq = String(maxSeq + 1).padStart(3, "0");
        return `${originalBidNumber}_${nextSeq}`;
    }
    catch (error) {
        console.error("inhouseBidNumber 생성 중 에러:", error);
        // 필요에 따라 기본값을 리턴하거나 에러를 던집니다.
        throw new Error("사내 견적번호 생성에 실패했습니다.");
    }
}
/**
 * @description 저장 시 다음 프로젝트 코드 생성
 * @param originalProjectCode 기존 프로젝트 코드
 */
export async function setProjectCode(originalProjectCode) {
    try {
        // 1) 백엔드에 projectCode 쿼리로 요청
        const response = await getProject(originalProjectCode);
        // 2) originalProjectCode_XXX 형태만 골라서 뒤 세 자리 숫자(문자열) 추출
        const regex = new RegExp(`^${originalProjectCode}_(\\d{3})$`);
        const seqNumbers = response
            .map((item) => item.projectCode.match(regex)?.[1])
            .filter((s) => !!s)
            .map((s) => Number(s));
        // 3) 최대값 +1, 없으면 1로 처리
        const maxSeq = seqNumbers.length ? Math.max(...seqNumbers) : 0;
        const nextSeq = String(maxSeq + 1).padStart(3, "0");
        return `${originalProjectCode}_${nextSeq}`;
    }
    catch (error) {
        console.error("프로젝트 코드 생성 중 에러:", error);
        // 필요에 따라 기본값을 리턴하거나 에러를 던집니다.
        throw new Error("프로젝트 코드 생성에 실패했습니다.");
    }
}
